var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":_vm.width,"height":_vm.height,"stroke":_vm.color,"viewBox":`0 0 24 24`,"xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{staticClass:"spinner"},[_c('circle',{attrs:{"cx":"12","cy":"12","r":"9.5","fill":"none","stroke-width":_vm.strokeWidth}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }